import { genericGet } from './apiService';
import { API_URL } from '../config/env';

const memoryCache = {
  countries: null,
  cities: new Map(),
  districts: new Map(),
};

const sessionGet = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const sessionSet = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // quota / private mode
  }
};

/**
 * Ülkeleri getir (session + memory cache)
 */
export const GetCountries = async () => {
  if (memoryCache.countries) return memoryCache.countries;

  const sessionKey = 'location:countries';
  const cached = sessionGet(sessionKey);
  if (cached?.data) {
    memoryCache.countries = cached;
    return cached;
  }

  const response = await genericGet(`${API_URL}Provice/GetCountries`);
  memoryCache.countries = response;
  sessionSet(sessionKey, response);
  return response;
};

/**
 * Şehirleri getir
 */
export const GetCities = async (id) => {
  if (id == null || id === '') return { data: [] };

  const key = String(id);
  if (memoryCache.cities.has(key)) return memoryCache.cities.get(key);

  const sessionKey = `location:cities:${key}`;
  const cached = sessionGet(sessionKey);
  if (cached?.data) {
    memoryCache.cities.set(key, cached);
    return cached;
  }

  const response = await genericGet(`${API_URL}Provice/GetCities?id=${id}`);
  memoryCache.cities.set(key, response);
  sessionSet(sessionKey, response);
  return response;
};

/**
 * İlçeleri getir
 */
export const GetDistrict = async (id) => {
  if (id == null || id === '') return { data: [] };

  const key = String(id);
  if (memoryCache.districts.has(key)) return memoryCache.districts.get(key);

  const sessionKey = `location:districts:${key}`;
  const cached = sessionGet(sessionKey);
  if (cached?.data) {
    memoryCache.districts.set(key, cached);
    return cached;
  }

  const response = await genericGet(`${API_URL}Provice/GetDistrict?id=${id}`);
  memoryCache.districts.set(key, response);
  sessionSet(sessionKey, response);
  return response;
};
